/**
 * The tmux sessions the server pushed (`{t:"sessions"}`, server/sessionsPush.ts),
 * as the board socket delivered them (admins only), replaced whole on each push.
 * Module-level, like lib/gitGraphs.ts: the socket lives in the board store, its
 * readers — the tmux view, the auto-pins, the Pipeline — only while they are up.
 * Nothing announces a push that was missed, so each reader reads
 * `GET /api/tmux/sessions` itself when it starts and on a reconnect (`sessionsGen`).
 */
import { ref, shallowRef } from "vue";
import type { TmuxSession } from "@shared/tmux.js";

/** The latest pushed list; null until one arrives. */
export const pushedSessions = shallowRef<readonly TmuxSession[] | null>(null);
/** Bumped by each socket (re)open: pushes may have been missed, read the list. */
export const sessionsGen = ref(0);

export function sessionsPushed(list: TmuxSession[]): void {
  pushedSessions.value = list;
}

export function sessionsResync(): void {
  sessionsGen.value++;
}
